
export const APP_TYPE = {
    1: '星伴'
}
export const BIND_TYPE = {
    //绑定方式1=邀请链接 2=邀请码 3=搜索短码 10=手动补录
    1: '邀请链接',
    2: '邀请码',
    3: '搜索短码',
    10: '手动补录',
}
export const IS_MIAN = {

    1: '小号',
    2: '大号',
}

export const IS_VIP = {
    0: '否',
    1: '是',
}

//支付类型

export const PAY_TYPE = {
    1: '支付宝',
    2: '微信',
    3: '苹果',
    4: '网页支付宝',
    5: '网页微信',
    6: '杉德网页云闪付',
    7: '杉德支付宝',
    8: '杉德微信',
    9: '汇聚支付宝',
    10: '汇聚微信',
    11: '汇付支付宝',
    12: '汇付微信',
    13: '原生微信jsapi',
    14: '汇付微信jsapi',
    15: '杉德微信jsapi'
}

export const ADDITI_STATE = {
    0: '待审核',
    1: '通过',
    2: '拒绝',
}

//绑定状态 1=已绑定 0=闲置未绑定 10=禁止绑定(拒绝)
export const BIND_STATUS = {
    0: '闲置未登录',
    1: '已绑定',
    2: '绑定失败',
    10: '禁止绑定(拒绝)'
}


